(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .constant('USER_QUERY_COUNTER_TYPES', [
       {'id': 0, 'type': 'users.model.usertests.type.docs' },
       {'id': 1, 'type': 'users.model.usertests.type.chars' }  ]);
})();
